import { QueryErrorBoundary } from '@/components/shared/error-boundary-overlay/query-error-boundary'
import { ChangelogCard } from '@/routes/home/changelog/changelog'
import { ChangelogCardFallback } from '@/routes/home/changelog/fallback'
import { SEVALLA_CHANGELOG_QUERY } from '@/routes/home/changelog/query'

export const Changelog = () => {
  return (
    <QueryErrorBoundary
      queries={[SEVALLA_CHANGELOG_QUERY]}
      fallback={<ChangelogCardFallback />}
    >
      <ChangelogCard />
    </QueryErrorBoundary>
  )
}
